import { Box, Theme } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { INode, INodeProps } from '@/types/node';
import { getSpacerValue } from '@/lib/utils/format';
import { IContent } from './contract';
import { useNodeProps } from '@/node-editor/hooks';
import { ConferenceContext } from '@/store';
import { useTheme } from '@mui/material/styles';

interface INodeExtended extends Omit<INode, 'content'> {
  content: IContent;
}

interface IProps extends Omit<INodeProps, 'node'> {
  node: INodeExtended;
}

const useStyles = (
  theme: Theme,
  { override }: { override: Record<string, any> }
) => ({
  root: {
    width: '100% !important',
    '& .pretix-widget': {
      border: 'none !important',
    },
    '& .pretix-widget a': {
      color: `${theme.palette.primary.main} !important`,
    },
    '& .pretix-widget button': {
      color: `${theme.palette.primary.contrastText} !important`,
      backgroundColor: `${theme.palette.primary.main} !important`,
      borderColor: `${theme.palette.primary.main} !important`,
    },
    ...override.root,
  },
});

/**
 * Embed Node description...
 */
export const Render = ({
  node: {
    id,
    override,
    content: { eventUrl },
  },
}: IProps) => {
  const classes = useStyles(useTheme(), { override });
  const { conferenceState } = useContext(ConferenceContext);

  useEffect(() => {
    window.PretixWidget && window.PretixWidget.buildWidgets();
  }, []);

  const url =
    eventUrl ||
    (conferenceState.conferenceDetail.pretix_id &&
      conferenceState.conferenceDetail.organization &&
      conferenceState.conferenceDetail.organization.pretix_id &&
      `https://pretix.eu/${conferenceState.conferenceDetail.organization.pretix_id}/${conferenceState.conferenceDetail.pretix_id}`) ||
    '';
  console.log('url', url);
  return (
    <Box sx={classes.root} {...useNodeProps(id)}>
      {url ? (
        <pretix-widget event={url}></pretix-widget>
      ) : (
        <Box p={2}>No pretix url or integration</Box>
      )}
    </Box>
  );
};
